import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { HttpVerbsEnum } from '../shared/enums/http-verbs.enum';
import { RelatedConceptsSearchModel } from '../../Monitor/Shared/models/related-concepts-search.model';
import { RelatedConceptsResponseModel } from './model/related-concepts-response.model';
import { SearchRangeResponseApiModel } from './model/search-range-response-api.model';
import { NeptuneApi } from '../genericApi/neptune.api';

@Injectable()
export class MercuryApi {

    constructor(
        private neptuneApi: NeptuneApi
    ) {}

    public relatedConcepts(search: RelatedConceptsSearchModel): Observable<RelatedConceptsResponseModel> {
        const slug = '/mediaitems/relatedconcepts';

        return this.neptuneApi.api<RelatedConceptsResponseModel>(
            slug,
            search,
            HttpVerbsEnum.POST
        );
    }

    public searchRanges(): Observable<SearchRangeResponseApiModel> {
        return this.neptuneApi.api<SearchRangeResponseApiModel>(
            '/mediaitems/search-ranges',
            null,
            HttpVerbsEnum.GET
        );
    }
}
